
import { useAtom } from "jotai";
import { FC } from "react";
import style from "./style.module.css";
import { POP_UP_ACTION } from "@components/Sales/batch.type";
import { planTableSelectedPlanAtom } from "@utils/store/store";
import { BATCH_PLUS_TABLE_CTA } from "@utils/constants";

interface props {
  isAnyPlanPurchased: boolean;
  onClose: (clickFrom?: string, plan?: any) => void;
  triggerEvent: (actionType: POP_UP_ACTION) => void;
  ctaName: string;
  pageName: string;
  slug: string;
  openInIframe?: boolean;
}
const TableFooter: FC<props> = ({
  isAnyPlanPurchased,
  onClose,
  openInIframe,
  ctaName,
  triggerEvent,
  pageName,
  slug,
}) => {
  const [selectedPlan] = useAtom(planTableSelectedPlanAtom);


  const handleBuyNowClick = () => {
    triggerEvent(POP_UP_ACTION.BUY_NOW);
    onClose("buy_now", selectedPlan);
  };

  return (
    <section className="absolute bottom-0 left-0 right-0">
      <section className={style.footer}>
        <div>
          <div className={style.planTitle}>{selectedPlan?.title + " Plan"}</div>
          <div className={style.price_content}>
            <div className={style.price}>
              <span>
                {selectedPlan?.total > 0
                  ? `₹ ${Math.floor(selectedPlan?.total)}`
                  : "FREE"}
              </span>
              {selectedPlan?.discount > 0 &&
                selectedPlan?.total > 0 &&
                selectedPlan?.price > 0 && (
                  <span className={style.actual_price}>
                    ₹ {Math.floor(selectedPlan?.price)}
                  </span>
                )}
            </div>
            {selectedPlan?.discount > 0 && selectedPlan?.total > 0 && (
              <span className={style.discount_wrapper}>
                {Math.floor(selectedPlan?.discount)}% OFF
              </span>
            )}
          </div>
        </div>
        <button className={style.buy_now_cta} onClick={handleBuyNowClick}>
          {selectedPlan?.total > 0
            ? isAnyPlanPurchased
              ? BATCH_PLUS_TABLE_CTA.UPGRADE_NOW
              : BATCH_PLUS_TABLE_CTA.BUY_NOW
            : BATCH_PLUS_TABLE_CTA.ENROLL_NOW}
        </button>
      </section>
    </section>
  );
};

export default TableFooter;
